import { render, staticRenderFns } from "./GiftBox.vue?vue&type=template&id=02ee1c08&"
import script from "./GiftBox.vue?vue&type=script&lang=js&"
export * from "./GiftBox.vue?vue&type=script&lang=js&"
import style0 from "./GiftBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02ee1c08')) {
      api.createRecord('02ee1c08', component.options)
    } else {
      api.reload('02ee1c08', component.options)
    }
    module.hot.accept("./GiftBox.vue?vue&type=template&id=02ee1c08&", function () {
      api.rerender('02ee1c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/會員相關/GiftBox.vue"
export default component.exports